import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Contact from '@/components/Contact'
import ContactParty from '@/components/ContactParty'
import ErrorPage from '@/components/ErrorPage'
import Success from '@/components/Success'
import Search from '@/components/Search'
import PDFContact from '@/components/PDFContact'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/lp',
      name: 'Home',
      component: Home
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/contactParty',
      name: 'ContactParty',
      component: ContactParty
    },
    {
      path: '/error',
      name: 'ErrorPage',
      component: ErrorPage
    },
    {
      path: '/success',
      name: 'Success',
      component: Success
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/pdf',
      name: 'PDFContact',
      component: PDFContact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js